import { OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { ServiceBase } from '../../interfaces/service-base.interface';
import { FactoryBase } from '../../interfaces/factory-base.interface';
import { ReactiveCreateComponent } from '../reactive-create/reactive-create.component';

export abstract class ImplementedCreateComponent<T> extends ReactiveCreateComponent<T> implements OnInit {
  constructor(protected readonly service: ServiceBase<T>, protected readonly factory: FactoryBase<T>) {
    super();
  }

  public abstract initModel(): T;

  public getForm(): FormGroup {
    return this.factory.getFormGroup(this.model);
  }

  public loadModelFromForm() {
    this.model = this.factory.loadFromFormGroup(this.model, this.form);
  }

  public createModel(): Observable<T> {
    return this.service.store(this.model);
  }

  public ngOnInit() {
    super.ngOnInit();
  }
}
